<template>
  <CustomerStatsExpanded :customer="profile" class="gmf-customer-stats" />
</template>

<script>
import state from '@/state';
import CustomerStatsExpanded from '@/components/CustomerStatsExpanded.vue';

export default {
  components: {
    CustomerStatsExpanded,
  },
  name: 'MyProfileStatsExpanded',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    }
  },
};
</script>
